module.exports = __webpack_public_path__ + "img/chat.9a90e2bf.svg";